'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var flightInformation = {
    INTERNATIONAL_TICKET_NUMBER: (0, _reactIntl.defineMessages)({
        LOCAL_RESIDENT_OR_STAYING: {
            'id': 'formOverrides.flightInformation.LOCAL_RESIDENT_OR_STAYING',
            'defaultMessage': 'Do not have one (resident/staying for an extended period of time)'
        }
    })
};

exports.default = flightInformation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOverrides/flightInformation.js
// module id = 1382
// module chunks = 0